<template>
  <div>
    <div class="vm-search" style="display: flex;flex-direction: row;justify-content: space-between">
      <div style="position: relative">
        <div style="color: red;position: absolute;top: 50%;left: 0;transform: translateY(-50%);height: 13px">*</div>
        <el-date-picker
            v-model="filter.beginTime"
            value-format="yyyy-MM-dd"
            type="date"
            style="width: 150px;margin-right: 5px;margin-left: 13px"
            placeholder="选择开始日期"/>
        <el-date-picker
            v-model="filter.endTime"
            value-format="yyyy-MM-dd"
            type="date"
            style="width: 150px"
            placeholder="选择结束日期"/>
        <el-button
            :loading="status==='loading'"
            type="primary"
            size="mini"
            style="height: 26px; padding: 0 10px; margin-left: 10px;"
            @click="getList">
          查询
        </el-button>
      </div>
      <div>
        <el-switch
            v-model="money"
            active-text="不含税"
            inactive-text="含税"/>
      </div>
    </div>
    <el-table
        ref="table"
        v-loading="status==='loading'"
        :data="tableData"
        style="width: 100%"
        row-key="pkId"
        height="calc(100vh - 20vh)"
        :tree-props="{children: 'children'}">
      <template slot="empty">
        <i v-if="status==='loading'" class="el-icon-loading" style="font-size: 18px"/>
        <el-button v-else-if="status==='error'" @click="getList">加载失败，点击重新获取</el-button>
        <div v-else-if="status==='empty'">暂无数据</div>
      </template>
      <el-table-column prop="customerName" width="210" align="center" label="客户"/>
      <el-table-column prop="totalMoneyOfDay" align="center" label="日销售额">
        <template slot-scope="scope">
          <span v-if="!money">{{scope.row.totalMoneyOfDay}}</span>
          <span v-else>{{parseFloat(scope.row.totalMoneyOfDay/1.13).toFixed(2)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="deliveryTotalMoneyOfDay" align="center" label="日发货额">
        <template slot-scope="scope">
          <span v-if="!money">{{scope.row.deliveryTotalMoneyOfDay}}</span>
          <span v-else>{{parseFloat(scope.row.deliveryTotalMoneyOfDay/1.13).toFixed(2)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalMoneyOfPeriod" align="center" label="区间销售额">
        <template slot-scope="scope">
          <span v-if="!money">{{scope.row.totalMoneyOfPeriod}}</span>
          <span v-else>{{parseFloat(scope.row.totalMoneyOfPeriod/1.13).toFixed(2)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="deliveryTotalMoneyOfPeriod" align="center" label="区间发生额">
        <template slot-scope="scope">
          <span v-if="!money">{{scope.row.deliveryTotalMoneyOfPeriod}}</span>
          <span v-else>{{parseFloat(scope.row.deliveryTotalMoneyOfPeriod/1.13).toFixed(2)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalMoneyOfMonth" align="center" label="本月至今销售额">
        <template slot-scope="scope">
          <span v-if="!money">{{scope.row.totalMoneyOfMonth}}</span>
          <span v-else>{{parseFloat(scope.row.totalMoneyOfMonth/1.13).toFixed(2)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="deliveryTotalMoneyOfMonth" align="center" label="本月至今发货额">
        <template slot-scope="scope">
          <span v-if="!money">{{scope.row.deliveryTotalMoneyOfMonth}}</span>
          <span v-else>{{parseFloat(scope.row.deliveryTotalMoneyOfMonth/1.13).toFixed(2)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalMoneyOfYear" align="center" label="本年至今销售额">
        <template slot-scope="scope">
          <span v-if="!money">{{scope.row.totalMoneyOfYear}}</span>
          <span v-else>{{parseFloat(scope.row.totalMoneyOfYear/1.13).toFixed(2)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="deliveryTotalMoneyOfYear" align="center" label="本年至今发货额">
        <template slot-scope="scope">
          <div>
            <span v-if="!money">{{scope.row.deliveryTotalMoneyOfYear}}</span>
            <span v-else>{{(parseFloat(scope.row.deliveryTotalMoneyOfYear)/1.13).toFixed(2)}}</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import dateUtil from "@/util/dateUtil";

  export default {
    name:"RobotSalesSummaryList",
    data() {
      return {
        status: "loading",
        money: false,
        tableData: [],
        filter: {
          beginTime: dateUtil.format(new Date(), "yyyy-MM-dd"),
          endTime: dateUtil.format(new Date(), "yyyy-MM-dd"),
        },
        ruleValidate: {
          beginTime: {required: true, message: "不能为空",trigger: "blur"},
          endTime: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    mounted() {
      this.initTime();
    },
    methods:{
      getList() {
        if(this.filter.beginTime ==="" ||this.filter.beginTime ==null) {
          return this.$message.error("开始时间不可为空!");
        }
        if(this.filter.endTime ==="" ||this.filter.endTime ==null) {
          return this.$message.error("结束时间不可为空!");
        }
        let params = {
          "beginTime": this.filter.beginTime,
          "endTime": this.filter.endTime,
        };
        this.status = "loading";
        this.$http
          .get("basic", "sd/so/getRobotSalesSummaryList", params).then(resp => {
            this.tableData = resp;
            console.log(this.tableData);
            if (resp.length === 0) {
              this.status = "empty";
            } else {
              this.status = "finish";
            }
          }).catch(() => {
            this.status = "error";
          });
      },
      // getMoney() {
      //   console.log(this.money);
      //   this.getList();
      // },
      initTime() {
        this.filter.endTime = this.getFormatDate(new Date());
        this.filter.beginTime = this.getFormatDate(new Date(new Date() - 3600 * 1000 * 24 * 7));
        this.getList(1);
      },
      // 获取当前时间
      getFormatDate(date) {
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        return date.getFullYear() + "-" + month + "-" + strDate;
      },
      dateCompare(date1,date2) {
        let time1 = date1.replace(/-/g,"");
        console.log(time1);
        let time2 = date2.replace(/-/g,"");
        console.log(time2);
        if(time1 <= time2) {
          return true;
        }else{
          return false;
        }
      },
    },
  };
</script>

<style scoped>
  .vm-search {
    margin: 10px;
  }
</style>